import { IAuthRepository, AuthLoginResponse } from '@gishub/domain';
import axios from 'axios';
import { MockAuthDatasource } from '../datasources/mock-auth-datasource';

export class AuthRepository implements IAuthRepository {
  private readonly http;
  private readonly mockAuth = new MockAuthDatasource();

  constructor(externalApiUrl: string) {
    this.http = axios.create({
      baseURL: externalApiUrl,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  setAccessToken(token: string): void {
    this.http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  clearAccessToken(): void {
    delete this.http.defaults.headers.common['Authorization'];
  }

  async externalLogin(username: string, password: string, alias: string, recaptchaToken?: string): Promise<AuthLoginResponse> {
    // Endpoint simulado: no se dispara ningún request HTTP real.
    const result = await this.mockAuth.login({ username, password, alias, recaptchaToken });
    if (!result.success || !result.data) {
      // Misma forma que un error del endpoint real para que
      // AuthProvider.getErrorMessage() resuelva el mensaje.
      const message = result.message ?? 'Credenciales inválidas';
      throw Object.assign(new Error(message), {
        response: { status: 401, data: { message } },
      });
    }
    return result.data;
  }
}